import {Trans} from '@lingui/macro';
import React, {FC, useState} from 'react';

import {IconButton} from '../../../../libs/shared/ui/src/components/buttons/iconButton';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {useClipboard} from '../../../helpers/hooks/clipboardHookHelpers';

/*
 * Props.
 */

interface ContactCardCopyButtonProps {
  copyValue: string;
}

/*
 * Component.
 */

export const ContactCardCopyButton: FC<ContactCardCopyButtonProps> = (props) => {
  const theme = useUserTheme();
  const {copyValue} = props;
  const [wasJustCopied, setWasJustCopied] = useState(false);
  const {copy} = useClipboard();

  const onCopyClick = () => {
    copy(copyValue);
    setWasJustCopied(true);
  };

  if (wasJustCopied) {
    return (
      <IconButton
        iconName="checkmarkBoxSmall"
        label={<Trans id="contact-card-item-copied">Copied!</Trans>}
        hoverColor={theme.palette.green.shade40}
        onMouseLeave={() => setWasJustCopied(false)}
      />
    );
  }
  return (
    <IconButton
      iconName="copySmall"
      color={theme.greys.shade70}
      label={<Trans id="contact-card-item-copy">Copy</Trans>}
      onClick={onCopyClick}
    />
  );
};
